import {isFeatureEnabled} from '@github-ui/feature-flags'

export function shouldParseCodeViewErrorResponse(response: {status: number}): boolean {
  return isFeatureEnabled('code_view_json_404') && response.status === 404
}
